import {
  RouteReuseStrategy,
  DetachedRouteHandle,
  ActivatedRouteSnapshot,
  Router,
  NavigationStart,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { GlobalService } from '../services/global.service';
import { LocationStrategy } from '@angular/common';
// import { ScrollPositionService } from './ScrollPosition.service';

@Injectable({
  providedIn: 'root',
})
export class CustomReuseStrategy implements RouteReuseStrategy {
  back: boolean = false;
  counter = 0;
  public handlers = new Map<string, DetachedRouteHandle>();

  constructor(public _gobalService: GlobalService, location: LocationStrategy) {
  }

  destroyRules = [
    // { type: 'exact', value: 'admin/edit-account/details' },
    // { type: 'exact', value: 'admin/notes/view' },
    // { type: 'exact', value: 'admin/donation/history' },
    // { type: 'exact', value: 'admin/donation/edit' },
    // { type: 'exact', value: 'admin/donation/possible-accounts' },
    // { type: 'exact', value: 'admin/user-groups' },
    // { type: 'exact', value: 'admin/user-tags' },
    // { type: 'exact', value: 'admin/permissions/details' },
    // { type: 'exact', value: 'admin/followup/details' },
    // { type: 'exact', value: 'admin/assign' },
    // { type: 'exact', value: 'myprofile' },
  ];

  getKey(route: ActivatedRouteSnapshot): string {
  return route.pathFromRoot
    .map(r => r.url.map(u => u.path).join('/'))
    .filter(Boolean)
    .join('/');
}

  getFullPath(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .map(r => r.routeConfig?.path)
      .filter(Boolean)
      .join('/');
  }

  normalizeKey(key: string): string {
    return key.startsWith('/') ? key : '/' + key;
  }

shouldDetach(route: ActivatedRouteSnapshot): boolean {
  // ❌ only cache real components
  if (!route.routeConfig || !route.routeConfig.component) {
    return false;
  }

  let fullPath = this.getFullPath(route);
  fullPath = fullPath.replace(':tenantId/', '');

  const shouldDestroy = this.destroyRules.some(rule => {
    if (rule.type === 'exact') return fullPath === rule.value;
    if (rule.type === 'startsWith') return fullPath.startsWith(rule.value);
    return false;
  });

  return !shouldDestroy; 
}

  private maxCache = 20;

store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
  if (!handle) return;

  const key = this.getKey(route);

  if (!key || key === '404') return;

  // 🔴 limit cache size BEFORE adding new one
  if (this.handlers.size >= this.maxCache) {
    const firstKey = this.handlers.keys().next().value;
    if (firstKey) {
      this.handlers.delete(firstKey);
    }
  }

  this.handlers.set(key, handle);
}

  getFullUrl(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .map(r => r.url.map(u => u.path).join('/'))
      .filter(Boolean)
      .join('/');
  }

shouldAttach(route: ActivatedRouteSnapshot): boolean {
  // only real components (leaf routes)
  if (!route.routeConfig || !route.routeConfig.component) {
    return false;
  }

  const key = this.getKey(route);

  return this._gobalService.isBack && this.handlers.has(key);
} 

retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
  const key = this.getKey(route);

  if (!this._gobalService.isBack) return null;

  const handle = this.handlers.get(key);

  // this._gobalService.isBack = false;

  return handle || null;
}

shouldReuseRoute(
  future: ActivatedRouteSnapshot,
  curr: ActivatedRouteSnapshot
): boolean {
  // 🔴 If we are going back → DO NOT let Angular recreate
  if (this._gobalService.isBack) {
    return false;
  }

  // otherwise normal behavior
  return future.routeConfig === curr.routeConfig;
}
}
